module.exports = __webpack_public_path__ + "img/item_32.dd52e249.png";